/* eslint-disable no-console */
import axios from 'axios';

let GRANERO_BASE = 'https://api.staging.planet-labs.com/features/v1';

// exported to support tests
export const GRANERO_ENVIRONMENTS = {
  next: 'https://api.staging.planet-labs.com/features/v1',
  live: 'https://api.planet.com/features/v1',
  local: 'http://localhost:8000/features/v1',
};

export let PROCESS_API_BASE = GRANERO_BASE.replace('v1', 'v0');

export const graneroInstance = axios.create({
  baseURL: GRANERO_BASE,
});

export const processAPIInstance = axios.create({
  baseURL: PROCESS_API_BASE,
});

/**
 * Set the target instance between next, live, and custom.
 *
 * @param {string} target When set to 'local', 'next' or 'live', target those GRANERO environments,
 *                        otherwise, set the target to the provided string.
 */
export const setGraneroTarget = target => {
  if (GRANERO_ENVIRONMENTS[target]) {
    GRANERO_BASE = GRANERO_ENVIRONMENTS[target];
  } else {
    GRANERO_BASE = target;
  }

  graneroInstance.defaults.baseURL = GRANERO_BASE;

  PROCESS_API_BASE = GRANERO_BASE.replace('v1', 'v0');
  processAPIInstance.defaults.baseURL = PROCESS_API_BASE;

  return GRANERO_BASE;
};

/**
 * Set the default Auth Token to be used with Auth Header
 * @param {string} token A JWT token.
 */
export const setAuthToken = accessToken => {
  graneroInstance.defaults.headers.Authorization = `Bearer ${accessToken}`;
  processAPIInstance.defaults.headers.Authorization = `Bearer ${accessToken}`;
};
